<template>
    <div style="width:100%;" align="center">
        <div class="form-group quiz-image-upload">
            <input type="file"
                   tabindex="-1"
                   v-if="uploadReady"
                   name="quizImage"
                   :id="fieldName"
                   @change="tryToUpload"
                   style="width:100%"/>
            <div class="file-dummy"
                 v-bind:class="{
                 'file-dummy-success':this.status==='success',
                 'file-dummy-loading':this.status==='loading',
                 'file-dummy-error':this.status==='error'
                 }">
                <i class="fa fa-image"> </i> <b>Upload Image</b><br/><span v-html="statusText"></span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            'qid': String,
            'imageUploadRoute': String,
        },
        data: function () {
            return {
                status: 'default',
                errorMessage: '',
                allowedFileExtensions: ['jpg', 'jpeg', 'gif', 'png', 'svg'],
                fieldName: this.qid + '_imageUpload',
                uploadReady: true,
                fileName: '',
            };
        },
        computed: {
            statusText: function () {
                switch (this.status) {
                    case 'success':
                        return 'File was uploaded!<br/>' + this.fileName;
                    case 'loading':
                        return '<i class="fa fa-spinner fa-spin"></i> Uploading...';
                    case 'error':
                        return this.errorMessage + '<br/>' + this.fileName;
                    default:
                        return 'Click or drop file!';
                }
            },
        },
        methods: {
            upload(file) {
                const formData = new FormData();
                formData.append('quizImage', file, file.name);
                let vm = this;
                return axios.post(this.imageUploadRoute, formData)
                    .then(function (res) {
                        vm.status = 'success';
                        vm.$emit('quizImageUploaded', res.data);
                    })
                    .catch(function (err) {
                        vm.throwError(err.message);
                    });
            },
            setNewFile(url) {

            },
            FileSelectHandler(e) {
                let files = e.target.files || e.dataTransfer.files;
                $('#' + this.qid + '_imageUpload').prop('files', e.originalEvent.dataTransfer.files);
            },
            clearFile() {
                this.uploadReady = false;
                this.$nextTick(() => {
                    this.uploadReady = true;
                });
            },
            throwError(message) {
                this.errorMessage = message;
                this.clearFile();
                this.status = 'error';
            },
            tryToUpload(e) {
                let files = e.target.files || e.dataTransfer.files;
                if (!files.length) {
                    this.throwError('No File Found!');
                    return;
                }

                let file = files[0];
                this.fileName = file.name;

                if (this.allowedFileExtensions.indexOf(file.name.split('.').pop().toLowerCase()) === -1) {
                    this.throwError('Faulty file type: ' + file.name.split('.').pop());
                    return;
                }
                this.upload(file);
            },
        }
    };
</script>
